// Generic helper to get a claim by FeatureKey
export const getClaim = (currentUser, featureKey) =>
  currentUser?.Extras?.UserExtrasClaims?.find(
    (c) => c.FeatureKey === featureKey
  ) || null;

// Get subscription claims from Subscription.Extras.Features
export const getSubscriptionClaim = (currentUser, featureKey) =>
  currentUser?.Subscription?.Extras?.Features?.find(
    (c) => c.Key === featureKey
  ) || null;

//maxReached
export const alertsMaxReached = (currentUser) =>
  getSubscriptionClaim(currentUser, "alert")?.MaxReached;
export const reportsMaxReached = (currentUser) =>
  getSubscriptionClaim(currentUser, "repor")?.MaxReached;
export const datasetMaxReached = (currentUser) =>
  getSubscriptionClaim(currentUser, "dataset")?.MaxReached;
export const dataSourceMaxReached = (currentUser) =>
  getSubscriptionClaim(currentUser, "datas")?.MaxReached;
export const expressionMaxReached = (currentUser) =>
  getSubscriptionClaim(currentUser, "expre")?.MaxReached;
export const usersMaxReached = (currentUser) =>
  getSubscriptionClaim(currentUser, "numuse")?.MaxReached;
export const dataCorrecMaxReached = (currentUser) =>
  getSubscriptionClaim(currentUser, "datacorrec")?.MaxReached;
export const scheduleMaxReached = (currentUser) => false;
export const connectionMaxReached = (currentUser) => false; // getSubscriptionClaim(currentUser, "schedrep")?.MaxReached;

// Generic function to check CanAccess
export const canAccessFeature = (currentUser, featureKey) =>
  currentUser &&
  currentUser.IsAuthenticated &&
  getClaim(currentUser, featureKey)?.CanAccess;

//in the below, can access is true if any of the following is true: CanViewResolved, CanCreateResolved, CanEditResolved, CanDeleteResolved
//Can{XXX}Resolved is true if the subscription CanAccess the XXX(which is true if Max is null or > NoValue) AND The user is subscription or root or has the claim
// === Specific helpers ===
export const canAccessExpressions = (currentUser) =>
  canAccessFeature(currentUser, "expre");
export const canAccessDataSources = (currentUser) =>
  canAccessFeature(currentUser, "datas");
export const canAccessAlerts = (currentUser) =>
  canAccessFeature(currentUser, "alert");
export const canAccessUsers = (currentUser) =>
  canAccessFeature(currentUser, "numuse");
export const canAccessReports = (currentUser) =>
  canAccessFeature(currentUser, "repor");
export const canAccessDataSet = (currentUser) =>
  canAccessFeature(currentUser, "dataset");
export const canAccessDataCorrection = (currentUser) =>
  canAccessFeature(currentUser, "datacorrec");
export const canAccessSchedule = (currentUser) => true; // canAccessFeature(currentUser, "schedrep");
export const canAccessConnection = (currentUser) => true; // canAccessFeature(currentUser, "schedrep");

export const canAccessMigrations = (currentUser) =>
  currentUser &&
  currentUser.IsAuthenticated &&
  currentUser.Subscription &&
  currentUser.Subscription.Name.toLowerCase() == "model" &&
  currentUser.Extras.Migrations.CanAccess;

//for reports, we no more have CanView because it'll be resolved at runtime based on the security group that the user belongs to
//the server returns CanAccess for reports as CanCreateResolved || CanEditResolved || CanDeleteResolved
// Example: for create/edit reports
export const canCreateOrEditReports = (currentUser) => {
  const claim = getClaim(currentUser, "repor");
  return (
    currentUser &&
    currentUser.IsAuthenticated &&
    (claim?.CanCreateResolved || claim?.CanEditResolved)
  );
};

export const canCreateReports = (currentUser) =>
  getClaim(currentUser, "repor")?.CanCreateResolved;
export const canEditReports = (currentUser) =>
  getClaim(currentUser, "repor")?.CanEditResolved;
export const canDeleteReports = (currentUser) =>
  getClaim(currentUser, "repor")?.CanDeleteResolved;
export const canViewAnyReport = (currentUser) =>
  getClaim(currentUser, "repor")?.CanViewAnyReportResolved;
export const canViewReport = (currentUser) =>
  getClaim(currentUser, "repor")?.CanView;
export const canManageSearchSchemaReport = (currentUser) =>
  getClaim(currentUser, "repor")?.CanManageSearchSchemaResolved;

//users
export const canViewUsers = (currentUser) =>
  getClaim(currentUser, "numuse")?.CanView;
export const canCreateUsers = (currentUser) =>
  getClaim(currentUser, "numuse")?.CanCreate;
export const canEditUsers = (currentUser) =>
  getClaim(currentUser, "numuse")?.CanEdit;
export const canDeleteUsers = (currentUser) =>
  getClaim(currentUser, "numuse")?.CanDelete;
export const canViewResolvedUsers = (currentUser) =>
  getClaim(currentUser, "numuse")?.CanViewResolved;
export const canCreateResolvedUsers = (currentUser) =>
  getClaim(currentUser, "numuse")?.CanCreateResolved;
export const canEditResolvedUsers = (currentUser) =>
  getClaim(currentUser, "numuse")?.CanEditResolved;
export const canDeleteResolvedUsers = (currentUser) =>
  getClaim(currentUser, "numuse")?.CanDeleteResolved;

//expressions
export const canViewExpressions = (currentUser) =>
  getClaim(currentUser, "expre")?.CanView;
export const canCreateExpressions = (currentUser) =>
  getClaim(currentUser, "expre")?.CanCreate;
export const canEditExpressions = (currentUser) =>
  getClaim(currentUser, "expre")?.CanEdit;
export const canDeleteExpressions = (currentUser) =>
  getClaim(currentUser, "expre")?.CanDelete;
export const canViewResolvedExpressions = (currentUser) =>
  getClaim(currentUser, "expre")?.CanViewResolved;
export const canCreateResolvedExpressions = (currentUser) =>
  getClaim(currentUser, "expre")?.CanCreateResolved;
export const canEditResolvedExpressions = (currentUser) =>
  getClaim(currentUser, "expre")?.CanEditResolved;
export const canDeleteResolvedExpressions = (currentUser) =>
  getClaim(currentUser, "expre")?.CanDeleteResolved;

//datasources
export const canViewDataSources = (currentUser) =>
  getClaim(currentUser, "datas")?.CanView;
export const canCreateDataSources = (currentUser) =>
  getClaim(currentUser, "datas")?.CanCreate;
export const canEditDataSources = (currentUser) =>
  getClaim(currentUser, "datas")?.CanEdit;
export const canDeleteDataSources = (currentUser) =>
  getClaim(currentUser, "datas")?.CanDelete;
export const canViewResolvedDataSources = (currentUser) =>
  getClaim(currentUser, "datas")?.CanViewResolved;
export const canCreateResolvedDataSources = (currentUser) =>
  getClaim(currentUser, "datas")?.CanCreateResolved;
export const canEditResolvedDataSources = (currentUser) =>
  getClaim(currentUser, "datas")?.CanEditResolved;
export const canDeleteResolvedDataSources = (currentUser) =>
  getClaim(currentUser, "datas")?.CanDeleteResolved;

//alerts
export const canViewAlerts = (currentUser) =>
  getClaim(currentUser, "alert")?.CanView;
export const canCreateAlerts = (currentUser) =>
  getClaim(currentUser, "alert")?.CanCreate;
export const canEditAlerts = (currentUser) =>
  getClaim(currentUser, "alert")?.CanEdit;
export const canDeleteAlerts = (currentUser) =>
  getClaim(currentUser, "alert")?.CanDelete;
export const canViewResolvedAlerts = (currentUser) =>
  getClaim(currentUser, "alert")?.CanViewResolved;
export const canCreateResolvedAlerts = (currentUser) =>
  getClaim(currentUser, "alert")?.CanCreateResolved;
export const canEditResolvedAlerts = (currentUser) =>
  getClaim(currentUser, "alert")?.CanEditResolved;
export const canDeleteResolvedAlerts = (currentUser) =>
  getClaim(currentUser, "alert")?.CanDeleteResolved;

// Root/subscription checks
export const isRootSubscriptionUser = (currentUser) =>
  currentUser &&
  currentUser.IsAuthenticated &&
  currentUser.Subscription?.IsRoot;
export const isUser = (currentUser) =>
  currentUser && currentUser.IsAuthenticated;

// Dataset permissions
export const canCreateOrEditDataset = (currentUser) => {
  const claim = getClaim(currentUser, "dataset");
  return (
    currentUser &&
    currentUser.IsAuthenticated &&
    (claim?.CanCreateResolved || claim?.CanEditResolved)
  );
};
export const canCreateDataset = (currentUser) =>
  getClaim(currentUser, "dataset")?.CanCreateResolved;
export const canEditDataset = (currentUser) =>
  getClaim(currentUser, "dataset")?.CanEditResolved;
export const canDeleteDataset = (currentUser) =>
  getClaim(currentUser, "dataset")?.CanDeleteResolved;
export const canViewAnyDataset = (currentUser) =>
  getClaim(currentUser, "dataset")?.CanViewResolved;
export const canImportDataset = (currentUser) =>
  getClaim(currentUser, "dataset")?.CanCreateResolved;

// Data correction
export const canCreateData = (currentUser) =>
  getClaim(currentUser, "datacorrec")?.CanCreate;
export const canEditData = (currentUser) =>
  getClaim(currentUser, "datacorrec")?.CanEdit;
export const canDeleteData = (currentUser) =>
  getClaim(currentUser, "datacorrec")?.CanDelete;
export const canViewData = (currentUser) =>
  getClaim(currentUser, "datacorrec")?.CanView;
export const canViewDataResolved = (currentUser) =>
  getClaim(currentUser, "datacorrec")?.CanViewResolved;
export const canCreateDataResolved = (currentUser) =>
  getClaim(currentUser, "datacorrec")?.CanCreateResolved;
export const canEditDataResolved = (currentUser) =>
  getClaim(currentUser, "datacorrec")?.CanEditResolved;
export const canDeleteDataResolved = (currentUser) =>
  getClaim(currentUser, "datacorrec")?.CanDeleteResolved;

// Data consumption (special case)
export const canAccessDataConsumption = (currentUser) =>
  currentUser &&
  currentUser.IsAuthenticated &&
  (currentUser.Extras.ViewConsumption || currentUser.Extras.ManageConsumption);

export const canCreateSchedule = (currentUser) => true; //getClaim(currentUser, "schedrep")?.CanCreateResolved;
export const canEditSchedule = (currentUser) => true; //getClaim(currentUser, "schedrep")?.CanEditResolved;
export const canDeleteSchedule = (currentUser) => true; //getClaim(currentUser, "schedrep")?.CanDeleteResolved;
export const canViewAnySchedule = (currentUser) => true; //getClaim(currentUser, "schedrep")?.CanViewResolved;
export const canImportSchedule = (currentUser) => true; //getClaim(currentUser, "schedrep")?.CanCreateResolved;

export const canCreateConnection = (currentUser) => true; //getClaim(currentUser, "schedrep")?.CanCreateResolved;
export const canEditConnection = (currentUser) => true; //getClaim(currentUser, "schedrep")?.CanEditResolved;
export const canDeleteConnection = (currentUser) => true; //getClaim(currentUser, "schedrep")?.CanDeleteResolved;
export const canViewAnyConnection = (currentUser) => true; //getClaim(currentUser, "schedrep")?.CanViewResolved;